import { useState } from 'react'
import toast from 'react-hot-toast'
import Modal from '../../ui/Modal'
import { deliveriesAPI } from '../../../api/deliveries'

interface Props {
  deliveryId: string
  trackingCode: string
  onClose: () => void
  onSuccess: () => void
}

export const ConfirmerRetourModal = ({ deliveryId, trackingCode, onClose, onSuccess }: Props) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleConfirm = async () => {
    setIsLoading(true)
    try {
      await deliveriesAPI.confirmerRetour(deliveryId)
      toast.success('Retour confirmé')
      onSuccess()
      onClose()
    } catch {
      toast.error('Erreur lors de la confirmation')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal open title="Confirmer le retour" onClose={onClose} size="sm">
      <div style={{
        background: '#FFF7ED', border: '1px solid #FED7AA',
        borderRadius: 10, padding: '14px 16px', margin: '4px 0 24px',
        fontSize: 13, color: '#92400E',
      }}>
        <strong>Colis {trackingCode}</strong>
        <p style={{ margin: '6px 0 0' }}>
          Confirmez que vous avez ramené ce colis à l'entrepôt ou chez l'expéditeur.
          Cette action est irréversible.
        </p>
      </div>

      <div style={{ display: 'flex', gap: 10 }}>
        <button
          onClick={onClose}
          style={{
            flex: 1, padding: '11px 0', borderRadius: 12,
            border: '1px solid #E5E7EB', background: '#F9FAFB',
            color: '#374151', fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
          }}
        >
          Annuler
        </button>
        <button
          onClick={handleConfirm}
          disabled={isLoading}
          style={{
            flex: 1, padding: '11px 0', borderRadius: 12, border: 'none',
            background: '#F59E0B', color: '#fff', fontSize: 14, fontWeight: 600,
            cursor: isLoading ? 'not-allowed' : 'pointer',
            opacity: isLoading ? 0.7 : 1, fontFamily: 'inherit',
          }}
        >
          {isLoading ? 'Confirmation...' : 'Retour confirmé'}
        </button>
      </div>
    </Modal>
  )
}
